import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { Location, LocationFormData } from '../types/boat.types';

export const locationApi = {
  // Get all locations (non-paginated)
  getLocations: (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    type?: string;
    is_active?: boolean;
  }) => tenantApi.getList<Location>('/locations', { params }),

  // Get single location
  getLocation: (id: number | string) =>
    tenantApi.getOne<Location>(`/locations/${id}`),

  // Create location
  createLocation: (locationData: LocationFormData) =>
    tenantApi.postOne<Location>('/locations', locationData),

  // Update location
  updateLocation: (id: number | string, locationData: Partial<LocationFormData>) =>
    tenantApi.putOne<Location>(`/locations/${id}`, locationData),

  // Delete location
  deleteLocation: (id: number | string) =>
    tenantApi.deleteOne(`/locations/${id}`),
};
